import { Button, IconButton, List, ListItem, ListItemIcon, ListItemText, makeStyles } from '@material-ui/core';
import { GitHub, YouTube, Menu, GetApp } from '@material-ui/icons';
import React, { useState } from 'react';
import { CloseBtn } from './Button';
import LoginComponent from './LoginComponent';

const useStyles = makeStyles((theme) =>({
    navButton : {
        color : '#fe752f',
        width : 'fit-content',
        marginTop : '2vh',
        "& .MuiSvgIcon-root" : {
            fontSize : '2.5rem !important',
            color : '#e5e7eb',
        }
    },
    mobileView : {
        color : '#fe752f',
        width : 'fit-content',
        "& .MuiSvgIcon-root" : {
            fontSize : '2.5rem !important',
            color : '#e5e7eb',
        }
    },
    icon : {
        color : '#fe752f',
        fontSize : '1.5rem !important',
        marginTop : '2vh', 
        "& .MuiSvgIcon-root" : {
            fontSize : '1.5rem !important',
            color : '#e5e7eb',
        },
        "& :hover" : {
            backgroundColor : 'transparent',
            color : '#fe752f',
            border : 'none',
        },
    }
}));

export default function Nav ({ view, visible, handleDownloadClick, handleNav }) {

    const classes = useStyles();

    if(view === 'mobile'){
        return(
            <div className="nav">
                <IconButton onClick={()=>{ handleNav(); }} classes={{ root: classes.mobileView }} >
                    <Menu />
                </IconButton>
            </div>
        )
    } else {
        return(
            <div className="nav">
                <LoginComponent />
                <div className="down" >
                    <IconButton disabled={!visible} onClick={handleDownloadClick}  classes={{ root : classes.icon }} >
                        <GetApp />
                    </IconButton>
                </div>
                <div className="git" >
                    <IconButton classes={{ root: classes.icon }} >
                        <GitHub />
                    </IconButton>

                </div>
                <div className="Utube" >
                    <IconButton classes={{ root: classes.icon }} >
                        <YouTube />
                    </IconButton>

                </div>
                {/* <IconButton classes={{ root: classes.navButton }} >
                    <Menu />
                </IconButton> */}
            </div>
        )
    }

};